/** Nothing here, and why.
 *
 * An empty table is a question — is it broken, or have I simply not done the
 * thing yet? So every empty state in this portal says which, and offers the
 * next move where there is one: no sessions until a logger has sent some, no
 * tokens until one is created, no issues because the job had nothing to ask.
 * "No data" on its own is never enough.
 */

import type { ReactNode } from 'react';

export interface EmptyStateProps {
  /** One line, sentence case, no full stop. */
  title: ReactNode;
  /** The explanation, or the instruction. */
  children?: ReactNode;
  /** A button or a link — whatever gets the visitor out of here. */
  action?: ReactNode;
  /** Tightens the padding for an empty state inside a card. */
  compact?: boolean;
  className?: string;
}

export function EmptyState({ title, children, action, compact, className }: EmptyStateProps) {
  return (
    <div
      className={className}
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 8,
        textAlign: 'center',
        padding: compact ? '20px 16px' : '48px 20px',
        color: 'var(--color-neutral-500)',
      }}
    >
      <div style={{ fontSize: 15, color: 'var(--color-neutral-300)' }}>{title}</div>
      {children ? (
        <div style={{ fontSize: 12.5, maxWidth: 460, textWrap: 'pretty' }}>{children}</div>
      ) : null}
      {action ? <div style={{ marginTop: 4 }}>{action}</div> : null}
    </div>
  );
}

export default EmptyState;
